import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import { Icon } from "@blueprintjs/core";
import checkmarkMarker from "../assets/icons/git/markers/checkmark.png";
import modifiedMarker from "../assets/icons/git/markers/modified.png";
import stagedMarker from "../assets/icons/git/markers/staged.png";
import symlinkIcon from "../assets/icons/symlink.png";
import dnaIcon from "../assets/icons/linear_dna.png";
import circularDnaIcon from "../assets/icons/plasmid.png";
import testTubeIcon from "../assets/icons/test_tube.png";
import assemblyIcon from "../assets/icons/assembly.png";
export const SEQUENCE_EXTENSIONS = [".gb", ".gbk", ".genbank", ".gen.gb", ".fasta", ".fa"];
export const ASSEMBLY_EXTENSIONS = [".assembly"];
export const JBROWSE_EXTENSIONS = [".jbrowse.zip"];
export const SAM_EXTENSIONS = [".sam.json"];
export const CHROMATOGRAM_EXTENSIONS = [".ab1"];
export const ALL_EDITABLE_EXTENSIONS = [
  ...SEQUENCE_EXTENSIONS,
  ...ASSEMBLY_EXTENSIONS,
  ...JBROWSE_EXTENSIONS,
  ...SAM_EXTENSIONS,
  ...CHROMATOGRAM_EXTENSIONS
];
export const IconWithGitOverlay = ({ baseIcon, isSymlink, gitStatus, inInventory, hasComments, isSelected }) => {
  let marker = null;
  const isStaged = gitStatus && gitStatus.length === 2 && gitStatus[0] !== " " && gitStatus[0] !== "?" && gitStatus[0] !== "!";
  const isModified = gitStatus && gitStatus.length === 2 && gitStatus[1] !== " ";
  const isUntracked = gitStatus === "??" || gitStatus && gitStatus.length === 2 && gitStatus[0] === "?" && gitStatus[1] === "?";
  const isClean = gitStatus === "tracked" || gitStatus === "  " || gitStatus === "tracked-dir";
  if (isUntracked) {
  } else if (isStaged) {
    marker = stagedMarker;
  } else if (isModified) {
    marker = modifiedMarker;
  } else if (isClean) {
    marker = checkmarkMarker;
  }
  return /* @__PURE__ */ jsxs("div", { style: { display: "flex", alignItems: "center", gap: "2px" }, children: [
    /* @__PURE__ */ jsxs("div", { style: { position: "relative", width: 16, height: 16, flexShrink: 0 }, children: [
      baseIcon,
      marker && /* @__PURE__ */ jsx(
        "img",
        {
          src: marker,
          "data-git-status-marker": marker === modifiedMarker ? "modified" : marker === stagedMarker ? "staged" : marker === checkmarkMarker ? "clean" : "unknown",
          title: marker === modifiedMarker ? "Modified" : marker === stagedMarker ? "Staged" : marker === checkmarkMarker ? "Clean" : "Status",
          style: {
            position: "absolute",
            bottom: -2,
            right: -2,
            width: 10,
            height: 10,
            backgroundColor: "white",
            borderRadius: "50%",
            padding: 1,
            boxShadow: "0 0 2px rgba(0,0,0,0.3)"
          },
          alt: "git status"
        }
      ),
      isSymlink && /* @__PURE__ */ jsx(
        "img",
        {
          src: symlinkIcon,
          style: {
            position: "absolute",
            top: -2,
            right: -2,
            width: 8,
            height: 8,
            backgroundColor: "white",
            borderRadius: "50%",
            boxShadow: "0 0 2px rgba(0,0,0,0.5)"
          },
          alt: "symlink"
        }
      )
    ] }),
    inInventory && /* @__PURE__ */ jsx(
      "img",
      {
        src: testTubeIcon,
        style: { width: 16, height: 16, flexShrink: 0 },
        alt: "in inventory",
        title: "In Inventory"
      }
    ),
    hasComments && /* @__PURE__ */ jsx(
      Icon,
      {
        icon: "chat",
        size: 14,
        style: { flexShrink: 0, color: isSelected ? "white" : "#5c7080", marginLeft: "2px" },
        title: "Has Comments"
      }
    )
  ] });
};
export const getFileIcon = (item, iconStyle = { width: 16, height: 16 }) => {
  const isDir = item.type === "directory";
  let baseIcon;
  if (isDir) {
    baseIcon = /* @__PURE__ */ jsx(Icon, { icon: "folder-close", style: { ...iconStyle, color: "#738694" } });
  } else if (SAM_EXTENSIONS.some((ex) => item.name.endsWith(ex))) {
    baseIcon = /* @__PURE__ */ jsx(Icon, { icon: "align-left", style: iconStyle });
  } else if (ASSEMBLY_EXTENSIONS.some((ex) => item.name.endsWith(ex))) {
    baseIcon = /* @__PURE__ */ jsx("img", { src: assemblyIcon, style: iconStyle, alt: "" });
  } else if (SEQUENCE_EXTENSIONS.some((ex) => item.name.endsWith(ex))) {
    if (item.circular) {
      baseIcon = /* @__PURE__ */ jsx("img", { src: circularDnaIcon, style: iconStyle, alt: "" });
    } else {
      baseIcon = /* @__PURE__ */ jsx("img", { src: dnaIcon, style: iconStyle, alt: "" });
    }
  } else if (JBROWSE_EXTENSIONS.some((ex) => item.name.endsWith(ex))) {
    baseIcon = /* @__PURE__ */ jsx(Icon, { icon: "database", style: iconStyle });
  } else if (CHROMATOGRAM_EXTENSIONS.some((ex) => item.name.endsWith(ex))) {
    baseIcon = /* @__PURE__ */ jsx(Icon, { icon: "pulse", style: iconStyle });
  } else {
    baseIcon = /* @__PURE__ */ jsx(Icon, { icon: "document", style: iconStyle });
  }
  return baseIcon;
};
